import React from "react";
import { Switch, Route } from "react-router-dom";
import Specs from "./Specs";

export default function SpecsView() {
  return (
    <div>
      <React.Fragment>
        <Switch>
          <Route
            exact
            path="/specs"
            render={(props) => <Specs {...props} />}
          />
        </Switch>
      </React.Fragment>
    </div>
  );
}
